<template>
    <div class="home" :style="[backgroundImage,backgroundColor]" v-if="show">
        <div class="ad" v-if="app.ad && duration > 0">
            <div class="duration" @click="hanldeShowHome">
                跳过{{duration}}
            </div>
            <img :src="app.ad.img" @load="onImageLoad" alt="">
        </div>

        <div class="banner" v-if="app.banner">
            <img :src="app.banner" alt="">
        </div>

        <div class="menu-list" v-if="app.menus && app.menus.length">
            <div v-for="(item,index) in app.menus" :key="index" :style="{width:app.menuWidth}" class="menu-item" @click="handleDetail(item,index)">
                <div class="icon">
                    <img :src="item.icon" alt="">
                </div>
                <span>{{item.name}}</span>
            </div>
        </div>

        <!-- 报名 -->
        <div class="box" :style="{'flex-direction': app.dir}">
            <div class="box-item" :style="{margin:item.top + 'px ' + item.right + 'px ' + item.bottom + 'px '  + item.left + 'px'}" v-for="(item,index) in app.sign" :key="index"
                 @click="handleDetail(item)">
                <span>{{item.name}}</span>
                <img :src="item.icon" alt="">
            </div>
        </div>

        <!-- 文章 -->
        <div class="article" v-if="app.articles && app.articles.length">
            <div class="article-title">
                {{app.articleTitle}}
                <div @click="handleArticleMore" class="more" v-if="app.articleMore">
                    <span>更多</span>
                    <svg-icon icon-class="arrow-right" style="color:#999;"></svg-icon>
                </div>
            </div>
            <div class="article-item" @click="handleDetail(item)" v-for="(item,index) in app.articles" :key="index">
                <div class="article-item-image">
                    <img :src="item.icon" alt="">
                </div>
                <div class="article-item-description">
                    <div class="article-item-title">{{item.title}}</div>
                    <div class="detail">
                        查看详情
                        <svg-icon icon-class="arrow-right" style="color:#999;"></svg-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- 展示 -->
        <div class="img-list " v-if="app.history && (app.history.title != '' || app.history.content != '<p><br></p>')">
            <div class="img-title" v-if="app.history.title">{{app.history.title}}</div>
            <div class="imgs ql-snow">
                <div class="img-item ql-editor" v-html="app.history.content">
                </div>
            </div>
        </div>

        <!-- <div class="address" v-if="localInfo" @click="getLocation">
            <div class="address-title">
                {{localInfo.poiname}}
            </div>
            <div class="address-poiaddress">
                {{localInfo.poiaddress}}
            </div>

            <div class="navigation">
                导航
                <svg-icon icon-class="navigation" style="color:#fff;"></svg-icon>
            </div>

        </div> -->
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';
import Banner from '@/components/Common/banner';
import wx from 'weixin-js-sdk';
import { getUrlCode } from '@/utils/index';
import { Toast } from 'vant';
export default {
    name: 'home',
    data() {
        return {
            app: {
                backdrop: '',
                primaryBg: '#fff',
            },
            localIn1fo: '',
            timer: null,
            duration: 0,
            show: false,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        backgroundImage() {
            return this.app.backdrop ? { backgroundImage: 'url(' + this.app.backdrop + ')' } : null;
        },
        backgroundColor() {
            return this.app.primaryBg ? { backgroundColor: this.app.primaryBg } : null;
        },
    },
    components: { Banner },
    beforeCreate() {
        if (getUrlCode().acid == 'o31k8r') {
            this.$router.push({
                path: '/',
                query: {
                    source: this.$route.query.source,
                    companyId: this.$route.query.companyId,
                    companyShareId: this.$route.query.companyShareId,
                    teamId: this.$route.query.teamId,
                },
            });
        }
    },
    mounted() {
        this.getJsApiTicket();
        this.handleData();
        this.checkAndRedirect();
    },
    methods: {
        hanldeShowHome() {
            this.duration = 0;
            sessionStorage.setItem('AdEnd', 'true');
            clearInterval(this.timer);
        },
        Countdown() {
            this.timer = setInterval(() => {
                this.duration--;
                if (this.duration <= 0) {
                    if (this.timer !== null) {
                        clearInterval(this.timer);
                        this.timer = null; // 将timer设为null以清除引用
                    }
                    sessionStorage.setItem('AdEnd', 'true');
                }
            }, 1000);
        },

        handleData() {
            httpRequest
                .get(`/api/ConfigPage/getModule?module=home`)
                .then(res => {
                    const { code, data } = res.data;
                    if (code == 200) {
                        var pageInfo = data;
                        this.app = JSON.parse(pageInfo.pageData);
                        let adEnd = sessionStorage.getItem('AdEnd');
                        if (adEnd != 'true') {
                            this.duration = this.app.ad ? this.app.ad.duration : 0;
                        }
                        this.$store.dispatch('SetHomeArticles', this.app.articles);
                    }
                })
                .finally(() => {
                    this.show = true;
                });

            httpRequest.get(`/api/TActivity/Info`).then(res => {
                const { code, data } = res.data;
                if (code == 200) {
                    this.localInfo = JSON.parse(data.address);
                }
            });
        },

        onImageLoad() {
            if (this.app.ad && this.duration > 0) this.Countdown();
        },

        getJsApiTicket() {
            let url = location.href.split('#')[0]; //获取锚点之前的链接
            httpRequest
                .get(`/api/visitor/GetJsApiTicket`, {
                    url: url,
                })
                .then(res => {
                    const { data, code, msg } = res.data;
                    if (code == 200) {
                        this.wxinit(data);
                    }
                });
        },

        wxinit(res) {
            let links = window.location.href;
            let title = this.defaultInfo.config.name;
            let desc =
                '时间：' + this.defaultInfo.config.startTime + '\r\n' + '地点：' + this.defaultInfo.config.address;
            let imgurl = this.defaultInfo.config.shareImg;

            wx.config({
                debug: false,
                appId: res.appId,
                timestamp: parseInt(res.timestamp),
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: [
                    'checkJsApi',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareAppMessage',
                    'openLocation',
                    'getLocation',
                ],
            });
            wx.ready(function () {
                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgurl, // 分享图标
                    success: function (res) {},
                });
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgurl, // 分享图标
                    success: function () {},
                    cancel: function () {},
                });
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgurl: imgurl, // 分享图标
                    success: function () {},
                    cancel: function () {},
                });
            });
        },

        getLocation() {
            var local = this.localInfo;
            if (!local) {
                Toast('定位未配置，请联系工作人员');
                return;
            }
            wx.openLocation({
                latitude: local.latlng.lat, // 纬度，浮点数，范围为90 ~ -90
                longitude: local.latlng.lng, // 经度，浮点数，范围为180 ~ -180。
                name: local.poiname, // 位置名
                address: local.poiaddress, // 地址详情说明
                scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
                infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
            });
        },

        handleArticleMore() {
            this.$router.push({
                path: '/article',
            });
        },

        handleDetail(item) {
            let link = item.link.replace('/', '');

            if (link == 'local') {
                this.getLocation();
                return;
            }

            if (link == 'login' || link == 'loginEn' || link == 'register' || link == 'event' || link == 'forum') {
                this.$router.push({
                    path: item.link,
                    query: {
                        source: this.$route.query.source,
                        companyId: this.$route.query.companyId,
                        companyShareId: this.$route.query.companyShareId,
                        teamId: this.$route.query.teamId,
                    },
                });
                return;
            }

            if (link.indexOf('http') > -1) {
                window.location.href = item.link;
            } else {
                this.$router.push({
                    path: item.link,
                    query: {
                        item: item,
                    },
                });
            }
        },

        checkAndRedirect() {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            }

            window.onpopstate = function (event) {
                // 获取当前URL
                const currentUrl = window.location.href;
                // 替换当前历史记录，使得后退会离开应用
                window.history.replaceState({}, '', currentUrl);
            };

            const currentUrl = window.location.href;

            // 替换当前历史记录，使得后退会离开应用
            window.history.replaceState({}, '', currentUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.home {
    font-size: 14px;
    height: 100vh;
    overflow-y: scroll;
    background-size: cover;

    .ad {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        .duration {
            position: absolute;
            right: 10px;
            top: 10px;
            padding: 6px 12px;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            border-radius: 4px;
        }
        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }
    .banner {
        img {
            width: 100%;
        }
    }
    .menu-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0px 8px 8px;
        .menu-item {
            display: flex;
            align-items: center;
            margin-top: 8px;
            flex-direction: column;
            .icon {
                width: 100%;
                height: 100%;
                border-radius: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    width: 100%;
                    height: auto;
                }
            }
            span {
                margin-top: 4px;
            }
        }
    }
    .address {
        background: rgba(0, 0, 0, 0.6);
        margin: 0 18px;
        padding: 8px;
        border-radius: 8px;
        color: #fff;
        .address-title {
        }
        .address-poiaddress {
        }
        .navigation {
            display: inline-block;
            padding: 8px 16px;
            border-radius: 36px;
            border: 1px solid #fff;
        }
    }
    .box {
        // display: flex;
        // justify-content: space-between;
        display: flex;
        padding: 8px;
        .box-item {
            display: flex;
            align-items: center;
            justify-content: space-between;

            flex: 1;

            border-radius: 8px;

            position: relative;

            span {
                font-size: 16px;
                color: #fff;
                position: absolute;
                left: 10px;
                top: 20px;
                z-index: 1;
            }
            img {
                width: 100%;
                height: auto;
            }
        }
        .box-item {
            span {
            }
        }
    }
    .img-list {
        .img-title {
            font-weight: bold;
            font-size: 18px;
            padding: 4px 18px;
            position: relative;
            &::after {
                position: absolute;
                left: 10px;
                border-radius: 4px;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                width: 4px;
                height: 60%;
                background: #327af6;
            }
        }
        .imgs {
            .img-item {
                ::v-deep img {
                    width: 100%;
                }
            }
            .ql-editor {
            }
        }
        .ql-snow {
        }
    }
    .article {
        .article-title {
            display: flex;
            justify-content: space-between;
            .more {
                color: #999;
                font-size: 14px;
                margin-right: 8px;
                display: flex;
                align-items: center;
                height: 100%;
                span {
                }
                .el-icon-arrow-right {
                }
            }
            padding: 8px 0;
            font-size: 15px;
            margin-bottom: 4px;
            padding-left: 24px;
            position: relative;
            &::after {
                position: absolute;
                left: 10px;
                border-radius: 4px;
                top: 50%;
                transform: translateY(-50%);
                content: '';
                width: 4px;
                height: 60%;
                background: #327af6;
            }
        }
        .article-item {
            display: flex;
            margin: 0 8px;
            padding: 8px 0;
            margin-bottom: 16px;

            border-bottom: 1px solid #eaeaea;
            .article-item-image {
                width: 160px;
                margin-right: 8px;
                img {
                    width: 160px;
                    height: 90px;
                    object-fit: contain;
                }
            }
            .article-item-description {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .article-item-title {
                    font-size: 14px;
                    line-height: 1.5;
                    height: 40px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                }
                .detail {
                    margin-top: 8px;
                    color: #999;
                    display: flex;
                    font-size: 14px;
                    justify-content: flex-end;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>